import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import {
  BATHROOM_REPAIR_ELEMENT_BLOCK,
  BATHROOM_REPAIR_SIGN_UP_HREF,
} from '../../../../bathroom-repair-constants';

type OneTeamProps = {
  regionId: string;
};

export const OneTeamModal = ({ regionId }: OneTeamProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.one-team.card-title')} />
      <ModalContent>
        <Typography variant="m" size="body_long">
          {t('utp-section.one-team.modal-description')}
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={BATHROOM_REPAIR_ELEMENT_BLOCK}
          elementName={`${t('utp-section.one-team.card-title')} / modal`}
          elementText={t('utp-section.modal-button')}
          href={`${BATHROOM_REPAIR_SIGN_UP_HREF}${regionId}`}
          target="_blank"
          wide>
          {t('utp-section.modal-button')}
        </ButtonWithGAClickButton>
      </ModalFooter>
    </>
  );
};
